import { Stack } from '@mui/material';
import React from 'react';

import { AttachOfferButton } from '@/components/emailWindow/components/attachments/components/attachOffer/AttachOfferButton.comp.tsx';
import { NewEmailAttachmentsItem } from '@/components/emailWindow/components/attachments/components/NewEmailAttachmentsItem.comp.tsx';
import { NewEmailAttachmentsUploadField } from '@/components/emailWindow/components/attachments/components/NewEmailAttachmentsUploadField.comp.tsx';
import { UUID } from '@/components/emailWindow/components/attachments/model/NewEmailAttachment.model.ts';
import { useDeleteAttachment } from '@/components/emailWindow/components/attachments/util/useDeleteAttachment.util.ts';
import {
  NEW_EMAIL_REDUCER_EVENT,
  useNewEmailAttachments,
  useNewEmailUpdateState,
} from '@/views/emails/context/NewEmails.ts';

interface Props {
  draftId: string | undefined;
}

const SCROLL_TO_ATTACHMENTS = 'SCROLL_TO_ATTACHMENTS';

export const NewEmailAttachments: React.FC<Props> = props => {
  const { draftId } = props;
  const { deleteAttachment } = useDeleteAttachment();
  const attachments = useNewEmailAttachments();
  const updateNewEmailState = useNewEmailUpdateState();

  if (!draftId) {
    return null;
  }

  const handleDeleteAttachment = async (externalAttachmentId: string, uuid: UUID) => {
    await deleteAttachment({ attachmentId: externalAttachmentId, emailId: draftId });
    updateNewEmailState({
      payload: { uuid },
      type: NEW_EMAIL_REDUCER_EVENT.ATTACHMENT_REMOVE,
    });
  };

  const handleSetAttachmentReady = (attachmentId: string) => {
    updateNewEmailState({
      payload: { attachmentId },
      type: NEW_EMAIL_REDUCER_EVENT.ATTACHMENT_SET_READY,
    });
  };

  return (
    <Stack spacing={1}>
      <NewEmailAttachmentsUploadField emailId={draftId} />
      <AttachOfferButton emailId={draftId} />
      <div id={SCROLL_TO_ATTACHMENTS} />
      <Stack
        direction="row"
        spacing={2}
        sx={{ flexWrap: 'wrap', pt: attachments.length > 0 ? 2 : 0 }}
      >
        {attachments.map(attachment => (
          <NewEmailAttachmentsItem
            attachment={attachment}
            emailId={draftId}
            key={attachment.attachmentId}
            onDeleteAttachment={handleDeleteAttachment}
            onSetAttachmentReady={handleSetAttachmentReady}
          />
        ))}
      </Stack>
    </Stack>
  );
};
